import React from "react";
import { Container, StyledFillEmailIcon } from "./styles";
export const HomepageThemeButtonDisplay = ({
  children
}) => /*#__PURE__*/React.createElement(Container, {
  "data-qa": "homepage-theme-button-display"
}, /*#__PURE__*/React.createElement(StyledFillEmailIcon, null), children);
HomepageThemeButtonDisplay.displayName = "HomepageThemeButtonDisplay";